import { createDecorator } from "vue-class-component";
import { computedCheckAuthorities, computedCheckUserRole } from "@/lib/helpers/componentViewController/index";
import { checkRuleCB } from "@/lib/types";

export const CheckAuthorities = (ruleName: string | checkRuleCB, authRuleKey: string | checkRuleCB) =>
  createDecorator((options, propertyKey) => {
    if (!options.computed) options.computed = {};
    options.computed[propertyKey] = function(this: any) {
      return computedCheckAuthorities.call(this, ruleName, authRuleKey);
    };
  });

export const CheckRole = (ruleName: string | checkRuleCB, currentUserRole: string | checkRuleCB) =>
  createDecorator((options, propertyKey) => {
    if (!options.computed) options.computed = {};
    options.computed[propertyKey] = function(this: any) {
      return computedCheckUserRole.call(this, ruleName, currentUserRole);
    };
  });

export const CheckRoleAndAuthorities = (
  ruleName: string | checkRuleCB,
  currentUserRole: string | checkRuleCB,
  authRuleKey: string | checkRuleCB
) =>
  createDecorator((options, propertyKey) => {
    if (!options.computed) options.computed = {};
    options.computed[propertyKey] = function(this: any) {
      const role = computedCheckUserRole.call(this, ruleName, currentUserRole);
      const auth = computedCheckAuthorities.call(this, ruleName, authRuleKey);
      return !!(auth && role);
    };
  });
